<template>
  <div>
    <v-row>
      <v-col class="d-flex flex-1 align-center justify-space-between">
        <span class="text-tcdc-green bold text-uppercase sub-header1" v-if="venue_hire && venue_hire.branch">{{venue_hire.branch.branch_name}}</span>
        <GreenLabel
                v-if="venue_hire && venue_hire.manual_url"
                :name="$t('venueHire.manual')"
                @onPress="goToManualURL(venue_hire.manual_url)"
        />
      </v-col>
    </v-row>
    <template v-if="venue_hire">
      <v-layout justify-space-between mt-7 mb-12 v-if="venue_hire.is_show">
        <v-flex shrink>
          <div class="d-flex align-center mb-2 sub-header2 bold" v-for="(v, i) in ventureList" :key="i">
            <v-img :src="v.img" v-if="v.img" contain class="mr-3 shrink" width="30px" height="30px"></v-img>
            <span class="text-tcdc-green text-uppercase">{{v[`text_${lang}`]}}</span>
          </div>
      </v-flex>
      <v-flex xs8>
        <div v-for="(venueHireDetail, i) in venue_hire.venue_hire_details" :key="i">
          <v-img
                  :src="venueHireDetail[0].floor.image_url"
                  width="100%"
                  class="cursor-pointer"
                  @click="onOpen(venueHireDetail)"
          ></v-img>
        </div>
      </v-flex>
    </v-layout>
      <div class="mb-5">
        <span class="text-tcdc-green sub-header2 bold mr-5" style="display: inline-block;">
          {{$t('venueHire.service')}}
        </span>
        <v-select
                class="text-uppercase"
                style="color: #2e8037; border: solid 1px #2e8037; display: inline-block;"
                outlined
                dense
                rounded
                menu-props="offset-y"
                color="#2e8037"
                item-color="#2e8037"
                placeholder="Sort by:"
                v-model="sortBy"
                v-if="venueHireType && venueHireType.length > 1"
                :items="venueHireType"
                :item-text="`name_${lang}`"
                item-value="type_id"
                hide-details
                @change="venuehireFilter"
                append-icon="mdi-menu-down"
        ></v-select>
      </div>
      <Divider />
      <div class="py-10 text-center grey--text" v-if="sortBy !== 0 && venue_hire_filtered.length < 1">
        {{$t('venueHire.itemNotFound')}}
      </div>
    <template v-for="(venueHireDetail, i) in sortBy === 0 ? venue_hire.venue_hire_details:venue_hire_filtered">
      <div :key="i" class="py-10 venture-tcdc-border-green">
        <span class="text-tcdc-green sub-header2 bold" v-if="venueHireDetail[0].floor">
          {{venueHireDetail[0].floor.floor_name}}
        </span>
          <v-row>
            <template v-for="x in venueHireDetail">
              <v-col cols="12" md="4" :key="x.id">
                <FloorCard
                        :title="x[`name_${lang}`]"
                        :content="x[`description_${lang}`]"
                        :slides="x.slide_images"
                        :enable-button="true"
                        @onBooking="onBooking"
                />
              </v-col>
            </template>
          </v-row>
        </div>
      </template>
      <v-row class="mt-10">
        <v-col cols="12"
               md="10">
        </v-col>
      </v-row>
      <v-row class="pt-10" id="contact-venuehire">
        <v-col class="mt-5" cols="12" md="10">
          <SendMessageForm @onSubmit="sendMsg" />
          <AlertModal
                  :show="modal"
                  :message="modalMsg"
                  @onConfirm="modal = false"
          ></AlertModal>
        </v-col>
      </v-row>
      <FloorModal :visible="visible" :data="floorModalData" @onClose="onClose" />
    </template>
  </div>
</template>

<script>
import GreenLabel from "../../components/labels/GreenLabel";
import Divider from "../../components/dividers/Divider";
import FloorCard from "../../components/cards/FloorCard";
import FloorModal from "../../components/modals/FloorModal";
import SendMessageForm from "../../components/form/SendMessageForm";
import AlertModal from "../modals/AlertModal";
import { mapState } from 'vuex'

export default {
  components: {
    GreenLabel,
    Divider,
    FloorCard,
    FloorModal,
    SendMessageForm,
    AlertModal
  },
  data: () => ({
    visible: false,
    sortBy: 0,
    venue_hire_filtered: [],
    floorModalData: [],
    modal: false,
    modalMsg: '',
    ventureList: [
      {
        text_th: "พื้นที่ให้เช่า",
        text_en: "Venue hire area",
        img: require('../../assets/icons/venue_hire/venue-hire.png')
      },
      {
        text_th: "ลิฟท์",
        text_en: "Elevator",
        img: require('../../assets/icons/venue_hire/elevator.png')
      },
      {
        text_th: "บันได",
        text_en: "Staircase",
        img: require('../../assets/icons/venue_hire/staircase.png')
      },
      {
        text_th: "บันไดเลื่อน",
        text_en: "Escalator",
        img: require('../../assets/icons/venue_hire/escalator.png')
      }
    ]
  }),
  created() {
    this.$store.dispatch('VenueHire/onGetVenueHireType');
  },
  computed: {
    ...mapState({
      venue_hire: state => state.ServiceMenu.venture_hire,
      branch_id : state => state.Branch.branch_id,
      branchName : state=> state.Branch.branch_name,
      lang: state => state.Branch.lang,
      venueHireType: state => {
        if (state.VenueHire.venue_hire_type) {
          return [
            { name_en: "Show all", name_th: "แสดงทั้งหมด", type_id: 0 },
            ...state.VenueHire.venue_hire_type
          ]
        }
      }
    })
  },
  methods: {
    onOpen(data) {
      this.floorModalData = data;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    goToManualURL(url){
      if(url){
        window.open(url , '_blank');
      }
    },
    onBooking() {
      this.$vuetify.goTo('#contact-venuehire');
    },
    venuehireFilter() {
      // console.log(this.sortBy)
      // console.log(this.venue_hire.venue_hire_details)
      let result = [];
      let floorResult = [];
      let roomResult = [];
      for (const floor of this.venue_hire.venue_hire_details) {
        for (const room of floor) {
          if(room.venue_hire_type_id && room.venue_hire_type_id.length > 0 && room.venue_hire_type_id.includes(this.sortBy)) {
            // console.log('room floor', room.floor.floor_name, 'type', room.venue_hire_type_id.toString())
            roomResult.push(room);
          }
        }
        if(roomResult.length > 0) {
          floorResult.push(roomResult)
          roomResult = [];
        }
      }
      if(floorResult.length > 0) {
        result = floorResult;
        floorResult = [];
      }
      // console.log('filter', result)
      this.venue_hire_filtered = result;
    },
    sendMsg(form) {
      form.branch_id = this.branch_id;
      if (form.email && form.phone) {
        this.$store.dispatch('Contact/sendMsgVenueHire', form).then(() => {
          this.modalMsg = this.$t('messageBox.success');
          this.modal = true;
        });
      } else {
        this.modalMsg = this.$t('messageBox.notValid');
        this.modal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.venture-tcdc-border-green {
  border-bottom: 2px solid $tcdcGreen;
}
.venture-tcdc-border-green:last-child {
  border-bottom: 0px solid white !important;
}
</style>
